module.exports = __webpack_public_path__ + "img/4.9db80d56.jpg";